import {connect} from '../../../app/connect';
import {updateRequiredFields} from '../../../app/actions';
import IssueRequiredAttributesAdminTable from './IssueRequiredAttributesAdminTable';
import {getRequiredFieldsFormatted, hasLocationsTreeNodes} from '../../../app/selectors';

const mapStateToProps = state => ({
  requiredFieldsMap: getRequiredFieldsFormatted(state),
  disableLocation: !hasLocationsTreeNodes(state)
});

const mapDispatchToProps = {
  updateRequiredFields
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRequiredAttributesAdminTable);
